import api from '../../../services/api';
import buildQuery from 'odata-query'

export const DTPS_URL = '/dtp'
export const STANDBY_URL = '/StandardStandBy'
export const TRAINING_URL = '/training'

// Pega todas as DTP
export function getAllDtp() {
    return api.get(DTPS_URL)
}

// Retorna os dados por filtro
export function getByFilters(queryParams) {
    return api.get(`${DTPS_URL}/odata${queryParams}`)
}

// Retorna os dados por filtro
export function fetchDataViewStandBy(id) {
    return fetchData(id, STANDBY_URL)
}

// Retorna a view
export function fetchDataViewDTP(id, trainingData = true) {
    return fetchData(id, DTPS_URL, trainingData)
}

// Retorna a view
export function fetchDataById(id) {
    return api.get(`${DTPS_URL}/odata/` + buildQuery({
        filter: {
            id: parseInt(id)
        },
        select: ['identifier']
    }))
}

// Retorna a view
export async function fetchData(id, url, trainingData = false) {   
    let returnValue = {};
    const baseData = await api.get(`${url}/odata/` + buildQuery({
        filter: {
            id: parseInt(id)
        },
        select: ['alertProcedure', 'createdAt', 'id', 'identifier', 'name', 'number', 'productActivity',
            'standardType', 'station', 'status', 'structureId', 'userId', 'version'],
        expand: {
            steps: true,            
            structure: {
                select: ['name']
            }
        }
    }))

    returnValue = baseData;

    let extraData = {};
    if (trainingData) {
        extraData = await api.get(`${url}/odata/` + buildQuery({
            filter: {
                id: parseInt(id)
            },
            select: [(url == STANDBY_URL ? 'standardId' : 'id')],
            expand: {
                trainingUsers: {
                    select: ['userId'],
                    expand: {
                        user: {
                            select: ['id', 'name', 'sap'],
                            expand: [
                                'companyRole',
                                'deparment'
                            ]
                        }
                    }
                },
                equipments: {
                    select: ['equipmentId'],
                }
            }
        }))
    }
    else {
        extraData = await api.get(`${url}/odata/` + buildQuery({
            filter: {
                id: parseInt(id)
            },
            select: [(url == STANDBY_URL ? 'standardId' : 'id')],
            expand: {                
                equipments: {
                    select: ['equipmentId'],
                }
            }
        }))
    }    

    returnValue.data.value[0].trainingUsers = extraData.data.value[0].trainingUsers;
    returnValue.data.value[0].equipments = extraData.data.value[0].equipments;
    if (url == STANDBY_URL)
        returnValue.data.value[0].standardId = extraData.data.value[0].standardId;

    return returnValue;
}

//Salva a DTP
export function updateDtp(dtp) {
    return api.put(dtp);
}


export function fetchDataTable(idFactory) {
    return api.get(`${DTPS_URL}/odata/` + buildQuery({
        filter: {
            'structure/factoryId': parseInt(idFactory),
            status: 'Official',
            version: { gt: 0 }
        },

        select: ['*'],
        expand: {
            structure: true
        },
        orderBy: ['UpdatedAt desc']
    }))
}


export function fetchTraining(id, version) {
    return api.get(`${TRAINING_URL}/odata/` + buildQuery({
        filter: {
            standardId: parseInt(id),
            version: version
        },
        expand: {
            users: {
                expand: {
                    user: {
                        select: ['id', 'name', 'sap'],
                        expand: [
                            'companyRole',
                            'deparment'
                        ]
                    }
                }
            }
        },
        count: true,
    }))
}

